export const FETCH_TOTALONBOARDINGRESIDENTS_INIT_ACTION = "FETCH_TOTALONBOARDINGRESIDENTS_INIT_ACTION";
export const FETCH_TOTALONBOARDINGRESIDENTS_SUCCESS_ACTION =
  FETCH_TOTALONBOARDINGRESIDENTS_INIT_ACTION + "_SUCCESS";
export const FETCH_TOTALONBOARDINGRESIDENTS_FAIL_ACTION =
  FETCH_TOTALONBOARDINGRESIDENTS_INIT_ACTION + "_ERROR";

  export const FETCH_RECIEVEDONBOARDINGRESIDENTS_INIT_ACTION = "FETCH_RECIEVEDONBOARDINGRESIDENTS_INIT_ACTION";
  export const FETCH_RECIEVEDONBOARDINGRESIDENTS_SUCCESS_ACTION =
    FETCH_RECIEVEDONBOARDINGRESIDENTS_INIT_ACTION + "_SUCCESS";
  export const FETCH_RECIEVEDONBOARDINGRESIDENTS_FAIL_ACTION =
    FETCH_RECIEVEDONBOARDINGRESIDENTS_INIT_ACTION + "_ERROR";

    export const FETCH_PENDINGONBOARDINGRESIDENTS_INIT_ACTION = "FETCH_PENDINGONBOARDINGRESIDENTS_INIT_ACTION";
  export const FETCH_PENDINGONBOARDINGRESIDENTS_SUCCESS_ACTION =
    FETCH_PENDINGONBOARDINGRESIDENTS_INIT_ACTION + "_SUCCESS";
  export const FETCH_PENDINGONBOARDINGRESIDENTS_FAIL_ACTION =
    FETCH_PENDINGONBOARDINGRESIDENTS_INIT_ACTION + "_ERROR";

    export const UPDATE_TOTALONBOARDINGRESIDENTS_INIT_ACTION = "UPDATE_TOTALONBOARDINGRESIDENTS_INIT_ACTION";
    export const UPDATE_TOTALONBOARDINGRESIDENTS_SUCCESS_ACTION =
    UPDATE_TOTALONBOARDINGRESIDENTS_INIT_ACTION + "_SUCCESS";
    export const UPDATE_TOTALONBOARDINGRESIDENTS_FAIL_ACTION =
    UPDATE_TOTALONBOARDINGRESIDENTS_INIT_ACTION + "_ERROR";

    export const UPDATE_PENDINGONBOARDINGRESIDENTS_INIT_ACTION = "UPDATE_PENDINGONBOARDINGRESIDENTS_INIT_ACTION";
    export const UPDATE_PENDINGONBOARDINGRESIDENTS_SUCCESS_ACTION =
    UPDATE_PENDINGONBOARDINGRESIDENTS_INIT_ACTION + "_SUCCESS";
    export const UPDATE_PENDINGONBOARDINGRESIDENTS_FAIL_ACTION =
    UPDATE_PENDINGONBOARDINGRESIDENTS_INIT_ACTION + "_ERROR";

    export const UPDATE_RECEIVEDONBOARDINGRESIDENTS_INIT_ACTION = "UPDATE_RECEIVEDONBOARDINGRESIDENTS_INIT_ACTION";
    export const UPDATE_RECEIVEDONBOARDINGRESIDENTS_SUCCESS_ACTION =
    UPDATE_RECEIVEDONBOARDINGRESIDENTS_INIT_ACTION + "_SUCCESS";
    export const UPDATE_RECEIVEDONBOARDINGRESIDENTS_FAIL_ACTION =
    UPDATE_RECEIVEDONBOARDINGRESIDENTS_INIT_ACTION + "_ERROR";